import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>To generate a <span
                                                className="brown brownbold">detailed</span> mental model, ask
                                                your audience to be as specific as possible when
                                                generating actions – not only will the detail be more tangible,
                                                but it will also be more
                                                readily applied.</p>
                                            <p>To generate a <span
                                                className="brown brownbold">robust</span> mental model,
                                                encourage comments and feedback from others so that
                                                learning is shared amongst the group. Feedback is important so
                                                that people can refine their
                                                mental models.</p>
                                            <p>Finally, to generate a <span
                                                className="brown brownbold">flexible</span> mental model, people
                                                must apply their own thinking rather than
                                                learning ‘by rote’. This is why it is so important to involve
                                                your audience in the ‘problem solving’ of
                                                translating the CAT into more tangible and specific tasks.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>CONSOLIDATION: A GUIDANCE CHECKLIST
                                            </div>
                                            <p>Here’s a checklist to consolidate what you've read, based on the
                                                PEA acronym we talked about
                                                at the beginning of the tool:</p>
                                            <p> Make a copy of it and tick off the sections as you complete
                                                them.</p>


                                            <table width="100%" border="0" cellSpacing="0" cellPadding="0"
                                                   className="ilead_v_sport  tablesrink uiheading ">
                                                <tbody>
                                                <tr>
                                                    <th width="20%" align="left" valign="top"
                                                        className="green_curve">Activity
                                                    </th>
                                                    <th width="40%" align="left" valign="top">Checklist</th>
                                                    <th width="4%" align="left" valign="top"
                                                        className=" green_curve1">Tick
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <th width="100%" align="left" valign="center"
                                                        className="lightblue " colSpan="3"><p><span
                                                        className="subtiltereg">Prepare</span></p></th>
                                                </tr>
                                                <tr>
                                                    <td width="25%" valign="top" towspan="1" align="left"
                                                        className="lightgreen">Personality
                                                    </td>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Does my message cater for 'big
                                                        picture' and 'practical, detail'
                                                        people?
                                                    </td>
                                                    <td width="10%" align="center" valign="middle"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="1"
                                                               id="Prepare1"
                                                               onChange={this.props.handleChangePageData('Prepare')}
                                                               checked={this.props.pageData?.Prepare?.[1]}/>
                                                        <label className="cursor-pointer" htmlFor="Prepare1">&nbsp;</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25%" rowSpan="2" className="lightgreen"
                                                        valign="top" align="left">Context and Task (CAT)
                                                    </td>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Am I being clear about the
                                                        overall Context?
                                                    </td>
                                                    <td width="10%" valign="middle" align="center"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="2"
                                                               id="Prepare2"
                                                               onChange={this.props.handleChangePageData('Prepare')}
                                                               checked={this.props.pageData?.Prepare?.[2]}/>
                                                        <label className="cursor-pointer" htmlFor="Prepare2">&nbsp;</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Am I clear about the Tasks that
                                                        will contribute to achieving the
                                                        Context - and making sure they're meaningful for those
                                                        assigned to them?
                                                    </td>
                                                    <td width="10%" valign="middle" align="center"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="3"
                                                               id="Prepare3"
                                                               onChange={this.props.handleChangePageData('Prepare')}
                                                               checked={this.props.pageData?.Prepare?.[3]}/>
                                                        <label className="cursor-pointer" htmlFor="Prepare3">&nbsp;</label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th width="100%" align="left" valign="center"
                                                        className="lightblue " colSpan="3"><p><span
                                                        className="subtiltereg">Explain</span></p></th>
                                                </tr>
                                                <tr>
                                                    <td width="25%" rowSpan="2" className="lightgreen"
                                                        valign="top" align="left">Creating the right environment
                                                    </td>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Have I planned enough time for
                                                        the meeting?
                                                    </td>
                                                    <td width="10%" valign="middle" align="center"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="1"
                                                               id="Explain1"
                                                               onChange={this.props.handleChangePageData('Explain')}
                                                               checked={this.props.pageData?.Explain?.[1]}/>
                                                        <label className="cursor-pointer" htmlFor="Explain1">&nbsp;</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Have I thought about how to
                                                        demonstrate confidence in the
                                                        ability of my audience?
                                                    </td>
                                                    <td width="10%" valign="middle" align="center"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="2"
                                                               id="Explain2"
                                                               onChange={this.props.handleChangePageData('Explain')}
                                                               checked={this.props.pageData?.Explain?.[2]}/>
                                                        <label className="cursor-pointer" htmlFor="Explain2">&nbsp;</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25%" valign="top" towspan="1" align="left"
                                                        className="lightgreen">Explaining the CAT
                                                    </td>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Have I clearly linked the Tasks
                                                        to the Context?
                                                    </td>
                                                    <td width="10%" align="center" valign="middle"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="3"
                                                               id="Explain3"
                                                               onChange={this.props.handleChangePageData('Explain')}
                                                               checked={this.props.pageData?.Explain?.[3]}/>
                                                        <label className="cursor-pointer" htmlFor="Explain3">&nbsp;</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="25%" rowSpan="2" className="lightgreen"
                                                        valign="top" align="left">Allowing opportunities for
                                                        questions
                                                    </td>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Have I allowed time for people to
                                                        ask questions?
                                                    </td>
                                                    <td width="10%" valign="middle" align="center"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="4"
                                                               id="Explain4"
                                                               onChange={this.props.handleChangePageData('Explain')}
                                                               checked={this.props.pageData?.Explain?.[4]}/>
                                                        <label className="cursor-pointer" htmlFor="Explain4">&nbsp;</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">Have I thought about answers to
                                                        likely questions from
                                                        different people?
                                                    </td>
                                                    <td width="10%" valign="middle" align="center"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="5"
                                                               id="Explain5"
                                                               onChange={this.props.handleChangePageData('Explain')}
                                                               checked={this.props.pageData?.Explain?.[5]}/>
                                                        <label className="cursor-pointer" htmlFor="Explain5">&nbsp;</label>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th width="100%" align="left" valign="center"
                                                        className="lightblue " colSpan="3"><p><span
                                                        className="subtiltereg">Ask</span></p></th>
                                                </tr>
                                                <tr>
                                                    <td width="25%" valign="top" towspan="1" align="left"
                                                        className="lightgreen">Involving
                                                    </td>
                                                    <td width="65%" valign="top" align="left"
                                                        className="lightgreen">What specific tasks do the
                                                        audience think will help them
                                                        achieve the Context and enable my vision?
                                                    </td>
                                                    <td width="10%" align="center" valign="middle"
                                                        className="lightgreen paddingcontrol">

                                                        <input type="checkbox"
                                                               name="1"
                                                               id="Ask1"
                                                               onChange={this.props.handleChangePageData('Ask')}
                                                               checked={this.props.pageData?.Ask?.[1]}/>
                                                        <label className="cursor-pointer" htmlFor="Ask1">&nbsp;</label>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>You should now have an approach to translate your vision into
                                                action and a checklist to help
                                                ensure that you are successful in working through all stages of
                                                the process. Here are a number
                                                of suggestions for your next steps having read through this
                                                tool:</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}